import type IRefinementDropdownList from './interfaces/IRefinementDropdownList';

import styles from './scss/ItemsTable.module.scss';

function RefinementDropdownList({ items, ariaLabel }: IRefinementDropdownList) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div
      className={styles.companiesDropdown}
      role="listbox"
      tabIndex={0}
      aria-label={ariaLabel}
    >
      <ul className={styles.companiesDropdownList}>
        {items.map((groupItem) => (
          <li
            key={groupItem}
            className={styles.companiesDropdownItem}
            role="option"
            aria-selected="false"
            tabIndex={0}
          >
            {groupItem}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default RefinementDropdownList;
